window.addEventListener(`DOMContentLoaded`, () => {
  const lfContainer = document.querySelector('.js-linked-funds-block')
  if (lfContainer) {
    const lfunds = lfContainer.querySelectorAll('[data-fund-page-id]')
    const lfundCurrent = lfContainer.querySelector('[data-res-id]')
    if (lfunds && lfundCurrent) {
      lfunds.forEach((l) => {
        if (l.dataset.fundPageId === lfundCurrent.dataset.resId) {
          l.classList.add('disabled')
        }
        if (l.classList.contains('not-active')) {
          l.querySelector('a').innerText = 'Скоро запуск'
          l.querySelector('a').setAttribute('href', 'javascript:void(0);')
        }
      })
    }
  }
})
